import type { AppRouteModule } from '@/router/types';
import { RoleEnum } from '@/enums/roleEnum';

const Checkout: AppRouteModule = {
  path: '/checkout',
  name: 'Checkout',
  identify: 'checkout',
  redirect: '/checkout/store',
  meta: {
    icon: 'ph:cash-register-light',
    title: '收银系统',
    orderNo: 2,
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'store',
      name: 'Stores',
      identify: 'checkout',
      component: () => import('@/views/checkout/store/index.vue'),
      meta: {
        title: '收银台',
        hideTab: true,
        hideMenu: true,
        currentActiveMenu: '/checkout',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'cashier',
      name: 'Cashier',
      identify: 'checkout',
      component: () => import('@/views/checkout/store/cashier.vue'),
      meta: {
        title: '收银台',
        hideTab: true,
        hideMenu: true,
        currentActiveMenu: '/checkout',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default Checkout;
